import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOff = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3859 6.38431C13.7865 7.00715 14.0007 7.59472 14.0007 7.9987C14.0007 9.33203 11.6673 12.6654 8.00065 12.6654C7.71331 12.6654 7.43415 12.6449 7.16366 12.6065M11.5292 4.47011C10.5789 3.80702 9.38477 3.33203 8.00065 3.33203C4.33398 3.33203 2.00065 6.66536 2.00065 7.9987C2.00065 8.82872 2.90487 10.4338 4.47207 11.5273M11.5292 4.47011L14.6673 1.33203M11.5292 4.47011L9.41487 6.58448M4.47207 11.5273L1.33398 14.6654M4.47207 11.5273L6.58644 9.41291M6.58644 9.41291C6.22451 9.05098 6.00065 8.55098 6.00065 7.9987C6.00065 6.89413 6.89608 5.9987 8.00065 5.9987C8.55294 5.9987 9.05294 6.22256 9.41487 6.58448M6.58644 9.41291L9.41487 6.58448",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgEyeOff);
export default ForwardRef;
